import { render, staticRenderFns } from "./ProofOfAddress.vue?vue&type=template&id=8e52e968&scoped=true"
import script from "./ProofOfAddress.vue?vue&type=script&lang=js"
export * from "./ProofOfAddress.vue?vue&type=script&lang=js"
import style0 from "./ProofOfAddress.vue?vue&type=style&index=0&id=8e52e968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e52e968",
  null
  
)

export default component.exports